const PickThumbnail = (props) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.01172 4.75C8.01172 5.85509 7.11681 6.75 6.01172 6.75C4.90771 6.75 4.01172 5.85509 4.01172 4.75C4.01172 3.64491 4.90771 2.75 6.01172 2.75C7.11573 2.75108 8.01064 3.64599 8.01172 4.75Z"
                stroke="#3871FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19 8.5C18.2598 7.84744 16.3363 6 14.7885 6C13.2399 6 11.3473 9.5 9.85802 9.5C8.36876 9.5 6.01584 8.15716 4.82251 9C3.62917 9.84215 2 12 2 12"
                stroke="#3871FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 0.75H17C18.2426 0.75 19.25 1.75736 19.25 3V10C19.25 11.2426 18.2426 12.25 17 12.25H3C1.75736 12.25 0.75 11.2426 0.75 10V3C0.75 1.75736 1.75736 0.75 3 0.75Z"
                stroke="#3871FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.60547 14.8623C1.82646 14.7257 2.10255 14.7131 2.33496 14.8291L5.33496 16.3291C5.58905 16.4561 5.75 16.7159 5.75 17C5.75 17.2841 5.58905 17.5439 5.33496 17.6709L2.33496 19.1709C2.10255 19.2869 1.82646 19.2743 1.60547 19.1377C1.38453 19.001 1.25 18.7598 1.25 18.5V15.5C1.25 15.2402 1.38453 14.999 1.60547 14.8623Z"
                stroke="#3871FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M15 17L19 17" stroke="#3871FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 17L12 17" stroke="#3871FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 17C15 17.8288 14.3288 18.5 13.5 18.5C12.672 18.5 12 17.8288 12 17C12 16.1712 12.672 15.5 13.5 15.5C14.328 15.5008 14.9992 16.172 15 17Z"
                stroke="#3871FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default PickThumbnail
